export default {
  /* Profile input name */
  setSettingsNameToCreate: (state, settingsNameToCreate) =>
    (state.settingsNameToCreate = settingsNameToCreate),

  /* Profiles */
  setSettings: (state, settings) => (state.settings = settings),
  addSettings: (state, settings) => state.settings.push(settings),

  /* Profile creation */
  setSettingsCreationPending: (state, value) =>
    (state.settingsCreationPending = value)
}
